module.exports = __webpack_public_path__ + "static/media/1361_MessageEducation_read_UH.e91a09ed.png";